
import { defineComponent } from 'vue'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import SchedulerDocumentAccordionTree from './SchedulerDocumentAccordionTree.vue'
import schedulerTimingOutputOutputTabDescriptor from '../SchedulerTimingOutputOutputTabDescriptor.json'

export default defineComponent({
    name: 'scheduler-document-accordion',
    components: { Accordion, AccordionTab, Checkbox, Dropdown, SchedulerDocumentAccordionTree },
    props: { propDocument: { type: Object }, functionalities: { type: Array }, datasets: { type: Array }, jobInfo: { type: Object } },
    data() {
        return {
            schedulerTimingOutputOutputTabDescriptor,
            document: null as any,
            drivers: [],
            documentNameDirty: false,
            datasetFolderLabelDrity: false,
            datasetFolderParameterDirty: false
        }
    },
    computed: {
        nameHelp(): string {
            return (this.document.documentname?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.document.nameMaxLength
        },
        descriptionHelp(): string {
            return (this.document.documentdescription?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.document.descriptionMaxLength
        }
    },
    watch: {
        propDocument() {
            this.loadDocument()
            this.loadDrivers()
        }
    },
    created() {
        this.loadDocument()
        this.loadDrivers()
    },
    methods: {
        loadDocument() {
            this.document = this.propDocument

            this.document.invalid.invalidDocument = false

            this.validateDocument(null)
        },
        loadDrivers() {
            const index = this.jobInfo?.documents.findIndex((el: any) => el.label === this.document.label)
            if (index !== -1) {
                this.drivers = this.jobInfo?.documents[index].parameters
            }
        },
        setSelectedFolders(folders: any[]) {
            this.document.funct = folders
            this.validateDocument(null)
        },
        validateDocument(dirty: string | null) {
            if (dirty) {
                this[dirty] = true
            }
            const nameInvalid = !this.document.documentname || this.document.documentname.length === 0
            const datasetInvalid = this.document.useFolderDataset && (!this.document.datasetFolderLabel || this.document.datasetFolderLabel?.length === 0 || !this.document.datasetFolderParameter || this.document.datasetFolderParameter?.length === 0)
            const foldersInvalid = this.document.useFixedFolder && (!this.document.funct || this.document.funct?.length === 0)

            this.document.invalid.invalidDocument = nameInvalid || datasetInvalid || foldersInvalid
        }
    }
})
